import { makeStyles } from "tss-react/mui";

const useProductInfoFormStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 999,
    color: "#fff",
  },
  image: {
    objectFit: "contain",
    height: "30vh",
  },
  zoomedImage: {
    objectFit: "contain",
  },
  schema: {
    height: 50,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,
    backgroundColor: theme.palette.surface.darker,
    padding: "8px",
  },
}));

export default useProductInfoFormStyles;
